import { PropTypes } from 'prop-types';
import { usePPDLagoon } from '@sde/widgets-core/src/tools/lagoon';

export const LagoonFeatures = ({ toggle, condition, alternate, children }) => {
  const { getFeature } = usePPDLagoon();
  const isEnabled = getFeature(toggle) && condition;

  if (typeof children === 'function') {
    return children(isEnabled);
  }

  return isEnabled ? children : alternate;
};

LagoonFeatures.propTypes = {
  toggle: PropTypes.string,
  condition: PropTypes.bool,
  alternate: PropTypes.node,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
};

LagoonFeatures.defaultProps = {
  toggle: null,
  condition: true,
  alternate: null,
  children: null,
};
